import { defineComponent as _defineComponent } from 'vue'
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import {
  Heading,
  Row,
  InitialAvatarIcon,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { Ref, computed, inject, ref } from 'vue';

import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLinks',
  props: {
    portfolioId: null
  },
  emits: ['openDelete', 'openRename', 'openChangeBackground'],
  setup(__props: any, { emit }) {

const props = __props as {
  portfolioId: string;
};

const router = useRouter();



const isPortfolioDistributionLoading = inject(
  'isPortfolioDistributionLoading'
) as Ref<boolean>;
const reloadCause = inject('reloadCause') as Ref<string>;
const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  inject<IPortfolioDistributionResponse>('portfolioDistribution')
);

function routeToWalletBuilderEdit() {
  router.push({
    name: 'catalogBuilder',
    params: {
      portfolioId: props.portfolioId,
      type: 'funds'
    }
  });
}

const portfolioName = computed(() => {
  if (
    isPortfolioDistributionLoading.value === true &&
    reloadCause.value === 'renamePortfolio'
  )
    return 'Carregando...';

  return portfolioDistribution.value?.portfolio?.name ?? '';
});

const isAllowedToDeletePortfolio = computed(() => {
  return !portfolioDistribution?.value?.portfolio?.shouldShowFeesMessage;
});

const showEditProducts = computed(() => {
  return (
    portfolioDistribution?.value?.portfolio?.isCustom &&
    portfolioDistribution.value.portfolio.canEditPortfolio
  );
});

const isAllowedToEditPortfolio = computed(() => {
  return portfolioDistribution.value?.portfolio?.canEditPortfolio;
});

return { __sfc: true,router, emit, props, isPortfolioDistributionLoading, reloadCause, portfolioDistribution, routeToWalletBuilderEdit, portfolioName, isAllowedToDeletePortfolio, showEditProducts, isAllowedToEditPortfolio, Heading, Row, InitialAvatarIcon, SkeletonLoader }
}

})